import { render, staticRenderFns } from "./Repurchase.vue?vue&type=template&id=2f24840a&scoped=true"
import script from "./Repurchase.vue?vue&type=script&lang=js"
export * from "./Repurchase.vue?vue&type=script&lang=js"
import style0 from "./Repurchase.vue?vue&type=style&index=0&id=2f24840a&prod&scoped=true&lang=css"
import style1 from "./Repurchase.vue?vue&type=style&index=1&id=2f24840a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f24840a",
  null
  
)

export default component.exports